<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="handleClick('insert')">新增</el-button>
                <el-button type="primary" @click="loadData(1)">刷新</el-button>
            </div>
            <div class="header-right">
                <el-input v-model="filterParams.product_appraisal" placeholder="评级编码" class="header-input" @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号" width="70">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="productName" label="钱币名称" width="250"></el-table-column>
            <el-table-column prop="productAppraisal" label="评级编码"></el-table-column>
            <el-table-column prop="salerName" label="代卖人"></el-table-column>
            <el-table-column prop="productPrize" label="钱币价格"></el-table-column>
            <el-table-column prop="logType" label="状态">
                <!-- <template slot-scope="scope">
                    <el-popover placement="top-start" trigger="hover" @show="popoverShow(scope.row.productId)"
                        v-if="scope.row.productStatus == 2 || scope.row.productStatus == 3 || scope.row.productStatus == 4">
                        <div>
                            <div v-for="item in popovers">{{ item.adminName }}：{{ getProductStatusName(item.resaleType)
                                }}</div>
                        </div>
                        <el-button type="text" slot="reference">{{ getProductStatusName(scope.row.productStatus)
                            }}</el-button>
                    </el-popover>
                    <span v-else>{{ getProductStatusName(scope.row.productStatus) }}</span>
                    <div v-if="adminSuper && scope.row.productStatus == 5" style="color: #FF0000; font-weight: bold;">{{ scope.row.lockName }}</div>
                    <div v-if="adminSuper && scope.row.productStatus == 6">
                        <span v-if="scope.row.productPay == 1">{{ scope.row.outName }}：{{ scope.row.productPay == 1 ? "已结算" : "未结算" }}</span>
                        <span v-else style="color: #FF0000; font-weight: bold;">{{ scope.row.outName }}：{{ scope.row.productPay == 1 ? "已结算" : "未结算" }}</span>
                    </div>
                </template> -->
                <template slot-scope="scope">
                    <div>{{ getLogTypeName(scope.row.logType) }}</div>
                    <div v-if="scope.row.logType == 6">
                        <span v-if="scope.row.productPay == 1">{{ scope.row.productPay == 1 ? "已结算" : "未结算" }}</span>
                        <span v-else style="color: #FF0000; font-weight: bold;">{{ getPayName(scope.row.productPay) }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="logMemo" label="日志备注"></el-table-column>
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.logDate) }}
                </template>
            </el-table-column>
            <el-table-column prop="coinImages" label="钱币图片" width="120">
                <template slot-scope="scope">
                    <div style="position: relative; width: 50px; height: 50px;" v-if="scope.row.productImages">
                        <el-image style="width: 50px; height: 50px;" :src="getFirstImageSrc(scope.row.productImages)" fit="cover"
                        :preview-src-list="getImageSrcList(scope.row.productImages)"></el-image>
                        <div v-if="scope.row.productImages.split(',').length > 1" style="position: absolute; background-color: #FF0000; top: 0px; right: 0px; z-index: 99; width: 20px; height: 20px; line-height: 20px; text-align: center; color: #FFFFFF; font-size: 12px; border-radius: 50%;">{{ scope.row.productImages.split(",").length }}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="90">
                <template slot-scope="scope">
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small">设置备注</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40, 100, 500]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="30%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="90px">
                    <el-form-item label="日志备注">
                        <el-input v-model="handleInfo.logMemo"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import imageMixin from "@/mixins/image-mixin.js"
import enumMixin from "@/mixins/enum-mixin.js"

export default {
    mixins: [verifyMixin, listMixin, imageMixin, enumMixin],
    data: function () {
        return {
        }
    },
    methods: {

    },
    created: async function () {
        this.tag = "LOG";
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
@import "@/assets/style/upload-style.less";
</style>